import React from 'react'
import { Form, Col } from 'react-bootstrap'
import { connect } from 'formik'
import PropTypes from 'prop-types'
import { useTranslation } from 'next-i18next'
import { getLocaleFormLabelKey } from '../../utils/helpers'

const propTypes = {
  fieldConfig: PropTypes.object.isRequired
}

function AddressLine1Control({ formik, fieldConfig, canEdit, alignCenter = true, columnSize = 5 }) {
  const { t } = useTranslation('common')
  let localizedFormLabel = t(getLocaleFormLabelKey(fieldConfig?.label))
  return (
    <Form.Group
      as={Col}
      md={columnSize}
      controlId="formAddress1"
      className={alignCenter ? 'mx-auto' : ''}
    >
      <Form.Label>{localizedFormLabel}</Form.Label>
      <Form.Control
        type="text"
        name="street1"
        value={formik.values.street1}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        placeholder={t('Street_address_PO_box_c_o')}
        isInvalid={!!formik.errors.street1}
        maxLength={255}
        readOnly={!canEdit}
        required={fieldConfig?.required}
      />
      <Form.Control.Feedback type="invalid">{formik.errors.street1}</Form.Control.Feedback>
    </Form.Group>
  )
}

AddressLine1Control.propTypes = propTypes

export default connect(AddressLine1Control)
